import { UserEntity } from "../entity/UserEntity";
import { User } from "../gateway/User/User";

export class GetUserUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ username, options = {} }) {
        if (!username) return null;
        const user = await this.UserGateway.getByUsername({
            username,
            options
        });
        if (!user) return null;
        const userEntity = UserEntity.restoreFromCloud(user);
        return userEntity;
    }
}
